import { render, staticRenderFns } from "./AssignedContactCard.vue?vue&type=template&id=ba57494a&scoped=true&"
import script from "./AssignedContactCard.vue?vue&type=script&lang=ts&"
export * from "./AssignedContactCard.vue?vue&type=script&lang=ts&"
import style0 from "./AssignedContactCard.vue?vue&type=style&index=0&id=ba57494a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba57494a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
